import { useQuery } from '@tanstack/react-query';

import { getV1BusinessPartnerCurrentProfilesOptions } from '../../api/generated/pap/@tanstack/react-query.gen';

/**
 * Shared query hooks for the profiles available to the current BusinessPartner.
 *
 * Thin wrapper over the generated `@hey-api` react-query options (new pattern).
 * The returned `ProfileBody` items carry `displayName` and `description`
 * strings from the API, which are used directly for display instead of being
 * re-derived from i18n translation keys.
 *
 * This is a foundational hook (it powers `useAppData` / the app provider), so
 * it lives in `src/hooks/queries/` rather than next to a single feature.
 */
export const useCurrentBusinessProfiles = (enabled: boolean = true) =>
  useQuery({
    ...getV1BusinessPartnerCurrentProfilesOptions(),
    enabled,
  });
